import React from 'react';

export class Heading1 extends React.Component {
    render() {
		return (
            <h1 className={this.props.classes}>{this.props.children}</h1>
        )
	}
}